/*
 * Ported verbatim from the legacy app's scripts/app/components/world-records.js.
 */
(function ($) {

    $(function () {

        var body = $('body');
        var html = $('html');

        var wr =  $('.world-records');

        if (wr.length > 0) {

            body.on('click', '.btn.wr_filter_show_all_classes',
                function () {

                    // Check if showall=true exists in current querystring
                    var search = window.location.search;
                    if (search.indexOf('showall=true') !== -1) {
                        search -= '&showall=true';
                    }
                    else {
                        search += '&showall=true';
                    }

                    window.location.search = search;

                    console.log('Showing all');
                });

            body.on('click', '.filter-group-item',
                function () {
                    //update active state of button and group
                    $(this).parent('.filter-group').children('.filter-group-item').removeClass('active');
                    $(this).addClass('active');

                    //Get an array of pressed filters
                    var curFilters = {};
                    var activeButtons = $('.filter-group-item.active');
                    $.each(activeButtons, function (index) {
                        var filter = $(activeButtons[index]);

                        var id = filter.attr('filter-id');
                        var name = filter.attr('filter-name');
                        var filteridentifier = filter.parent('.filter-group').attr('filter-identifier');

                        curFilters[filteridentifier] = {
                            id: id,
                            name: name
                        };
                        

                    });

                    console.log(curFilters);

                    if (curFilters['gender'] && curFilters['ageGroup']) {
                        //Both filters chosen - redirect
                        var newSearch = '?gender=' + curFilters.gender.name.toLowerCase() + '&agegroup=' + curFilters.ageGroup.name.toLowerCase();

                        // Check if showall=true exists in current querystring
                        var search = window.location.search;
                        if (search.indexOf('showall=true') !== -1) {
                            newSearch += '&showall=true';
                        }

                        window.location.search = newSearch;
                    }
                });
        }
        
        });
})(window.jQuery);
